export const appCdnURL = "/public/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"}],"link":[],"style":[],"script":[{"innerHTML":"var loadBabel = function(url, callback) {var script = document.createElement(\"script\");script.async = true;if (script.readyState) {script.onreadystatechange = function() {if (script.readyState == \"loaded\" || script.readyState == \"complete\") {script.onreadystatechange = null;callback(window, document);}};} else {script.onload = function() {callback(window, document);};}script.src = url;document.head.appendChild(script);};var getCookie = function(cname) {var objToday = new Date();var version = objToday.toISOString().split(\"T\")[0].split(\"-\").join(\"\");var name = cname + \"=\";var decodedCookie = decodeURIComponent(document.cookie);var cookieArray = decodedCookie.split(\";\");for (var i = 0; i < cookieArray.length; i++) {var cookie = cookieArray[i];cookie = cookie.trim();if (cookie.indexOf(name) == 0) {return cookie.substring(name.length, cookie.length);}}return version;};var loadWidget = function(window, document) {var __cp = {\"id\":\"ICq5XXf-7CM9U1ONNKrBoCE4IGQupY9cn8_2VDD5oNE\",\"version\":\"1.1\"};var cp = document.createElement(\"script\");cp.type = \"text/javascript\";cp.async = true;cp.src = \"++cdn-widget.callpage.io+build+js+callpage.js\".replace(/[+]/g, \"/\").replace(/[=]/g, \".\") + \"?v=\" + getCookie(\"callpage-widget-version\");var s = document.getElementsByTagName(\"script\")[0];s.parentNode.insertBefore(cp, s);if (window.callpage) {alert(\"You could have only 1 CallPage code on your website!\");} else {window.callpage = function(method) {if (method == \"__getQueue\") {return this.methods;} else if (method) {if (typeof window.callpage.execute === \"function\") {return window.callpage.execute.apply(this, arguments);} else {(this.methods = this.methods || []).push({arguments: arguments,});}}};window.callpage.__cp = __cp;window.callpage(\"api.button.autoshow\");}};loadBabel(\"https://cdnjs.cloudflare.com/ajax/libs/babel-polyfill/6.26.0/polyfill.min.js\", function() {return loadWidget(window, document);});","tagPosition":"bodyClose"}],"noscript":[],"htmlAttrs":{"lang":"cs","itemscope":true,"itemtype":"https://schema.org/WebPage"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true